var map = {
	"./bsc.svg": 47645,
	"./card.svg": 42533,
	"./cryptocloud.svg": 40563,
	"./enot.svg": 14619,
	"./morune.svg": 95455,
	"./paypal.svg": 32035,
	"./promo.svg": 79357,
	"./qiwi.svg": 9422,
	"./tron.svg": 72292
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 50314;